const DEFAULT_SIGNER_KEY_ENDPOINT = "/api/client/signer-key/{rentProcessId}";

export function resolveSignerKeyEndpoint(
  rentProcessId: number,
  template = DEFAULT_SIGNER_KEY_ENDPOINT
): string {
  const path = template.replace("{rentProcessId}", String(rentProcessId));

  return path.startsWith("/") ? path : `/${path}`;
}
